import React from "react";
import hobby from "../images/hobby.png";
import "./styles.css";
const Hobby = () => {
  return (
    <div className="section">
      <div className="row">
        <div className="col-xs-3" style={{ borderRadius: "50px!important" }}>
          <img
            src={hobby}
            alt="Hobby"
            style={{ borderRadius: "50%!important" }}
          />
        </div>
        <div className="col-xs-9">
          <div className="ptitle"> Hobbies</div>

          <div className="pbody">
            <p>
              I love to listen to music and cooking. If I am not writing code
              then you can find me in the kitchen.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Hobby;
